// extracted by mini-css-extract-plugin
module.exports = {"PositionsWrapper":"Positions-module__PositionsWrapper___2jm41","PositionsContent":"Positions-module__PositionsContent___1FfWM"};